import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * 特殊健診
 */
export default class TokushuKenshin extends BaseEnum{
    static IJONASHI = {value: '0', name: '異常なし'} as Enum
    static CHUI = {value: '1', name: '注意'} as Enum
    static SAISHIN = {value: '2', name: '再診'} as Enum
}
TokushuKenshin.values = [TokushuKenshin.IJONASHI, TokushuKenshin.CHUI, TokushuKenshin.SAISHIN]
